import { IPriority } from 'legacy/lut/classes/models/partner360/ELT/financialData/IPriority'

export const formPrioritiesData = (priorities: IPriority[]) => {
  return priorities.map((el) => el.Description || '')
}
